export default {
    label_task:{
        en:"Form Setup",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Form",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Form",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Form",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_entry_count:{
        en:"Number of Entry",
        bn:"প্রিফিক্স"
    },
    label_entry_interval:{
        en:"Interval",
        bn:"প্রিফিক্স"
    },
    label_entry_count_unknown:{
        en:"UnKnown",
        bn:"প্রিফিক্স"
    },
    label_show_inputs:{
        en:"Input Fields",
        bn:"প্রিফিক্স"
    },
    label_type:{
        en:"Type",
        bn:"প্রিফিক্স"
    },
    label_options:{
        en:"Options",
        bn:"প্রিফিক্স"
    },
    label_default:{
        en:"Default value",
        bn:"প্রিফিক্স"
    },
    label_mandatory:{
        en:"Mandatory",
        bn:"প্রিফিক্স"
    },
    label_task_input:{
        en:"Inputs Setup",
        bn:'ব্যবহারকারীরা'
    },
    label_class:{
        en:"Class",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task_input:{
        en:"New Input",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task_inupt:{
        en:"Edit Input",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task_input:{
        en:"Details of Input",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_new_input:{
        en:"New Input",
        bn:"প্রিফিক্স"
    },
    label_edit_input:{
        en:"Edit Input",
        bn:"প্রিফিক্স"
    },
}